// src/components/results/mapLCW.js
import React, {
  useMemo, useState, useCallback, useContext, useEffect, useRef
} from "react";
import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";
import AuthContext from "../../Context/AuthContext";

export default function MobilityMap({
  rawData = [],
  centerFallback = { lat: 41.04, lng: 28.99 },
  zoom = 12,
}) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCaHzltTBFsM9LOb9EDlMHdUV-m1Od0hF4",
  });
  const { userData } = useContext(AuthContext);

  const typeToColor = {
    "Bağdat Caddesi": "red",
    "Kent Vizyon": "blue",
    "Liste Tür": "green",
    "Panout Otobüs Durağı": "orange",
    "Urban CLP": "purple",
    "Urban Metrobus": "yellow",
    "YOVI Megalight": "pink",
    "YOVI ONTV": "ltblue",
  };

  const STORE_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg width="78" height="24" viewBox="0 0 78 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.14096 0.636818V19.2019H18.9082V23.4129H0.380371V0.636818H6.14096Z" fill="#18398E"></path><path d="M36.74 6.71426C36.3976 6.23618 35.9695 5.81546 35.4559 5.45403C34.9422 5.09259 34.36 4.81148 33.7132 4.60877C33.0645 4.40606 32.3853 4.30662 31.6776 4.30662C30.3801 4.30662 29.2805 4.52462 28.375 4.96064C27.4694 5.39666 26.737 5.98183 26.1739 6.71426C25.6107 7.44861 25.2017 8.28239 24.9449 9.21753C24.688 10.1546 24.5606 11.1203 24.5606 12.1205C24.5606 13.0767 24.688 14.008 24.9449 14.9125C25.2017 15.8171 25.6107 16.6298 26.1739 17.3527C26.737 18.0755 27.4694 18.655 28.375 19.091C29.2805 19.527 30.3801 19.745 31.6776 19.745C33.4393 19.745 34.8147 19.2784 35.8059 18.3414C36.7971 17.4062 37.402 16.1728 37.6227 14.641H43.1988C43.0523 16.0657 42.6718 17.3527 42.0611 18.5001C41.4485 19.6475 40.6419 20.6266 39.6393 21.4355C38.6367 22.2445 37.4629 22.8602 36.1179 23.2848C34.7729 23.7093 33.2928 23.9235 31.6776 23.9235C29.6724 23.9235 27.867 23.6194 26.2652 23.0151C24.6633 22.4089 23.3126 21.5751 22.2111 20.5119C21.1096 19.4486 20.2668 18.1998 19.6789 16.7637C19.0911 15.3275 18.7981 13.7804 18.7981 12.1224C18.7981 10.4204 19.0911 8.84271 19.6789 7.3855C20.2668 5.92829 21.1096 4.65849 22.2111 3.57419C23.3126 2.48988 24.6633 1.63889 26.2652 1.02311C27.867 0.403508 29.6705 0.0956192 31.6757 0.0956192C33.1178 0.0956192 34.4818 0.277293 35.7659 0.638727C37.0501 1.00016 38.1992 1.52606 39.2151 2.21833C40.2291 2.9106 41.068 3.76542 41.7282 4.78662C42.3883 5.80781 42.805 6.97626 42.9762 8.29578H37.4001C37.3012 7.72207 37.0824 7.19618 36.74 6.71618V6.71426Z" fill="#18398E"></path><path d="M64.8808 23.4148L60.4405 7.91139H60.3663L56.0002 23.4148H50.1673L43.2329 0.638725H48.9935L53.1389 16.1422H53.2131L57.7618 0.638725H63.1553L67.6317 16.3334H67.7059L71.9978 0.638725H77.648L70.6033 23.4148H64.8808Z" fill="#18398E"></path></svg>
    `);

  const BILLBOARD_SVG =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`<svg width="22" height="22" viewBox="0 0 22 22" fill="#1e40af" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="4" width="20" height="12" rx="2"/>
<rect x="9" y="16" width="4" height="4"/>
</svg>`);

  const GIANTBOARD_SVG =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`<svg width="22" height="22" viewBox="0 0 22 22" fill="#0f766e" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="3" width="22" height="14" rx="2"/>
<rect x="8" y="17" width="6" height="4"/>
</svg>`);

  const MEGALIGHT_SVG =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`<svg width="22" height="22" viewBox="0 0 22 22" fill="#f59e0b" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="16" height="16" rx="3"/>
</svg>`);

  const WALLBOARD_SVG =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`<svg width="22" height="22" viewBox="0 0 22 22" fill="#7c3aed" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="5" width="18" height="10" rx="1"/>
</svg>`);


  // ---- Noktalar
  const points = useMemo(() => {
    const norm = (v) => (typeof v === "string" ? v.replace(/\s+/g, " ").trim() : v) || null;

    // Renk alanına göre pin rengi belirleme
    const getColorFromRenk = (renk) => {
      if (!renk) return null;
      const r = renk.toLowerCase();
      if (r === "yeşil") return "green";
      if (r === "kırmızı") return "red";
      return null;
    };

    return (Array.isArray(rawData) ? rawData : [])
      .map((r, idx) => {
        const lat = Number(String(r.latitude).replace(",", "."));
        const lng = Number(String(r.longitude).replace(",", "."));
        const type = norm(r["Liste Tür"] ?? r["Liste  Tür"] ?? null);

        //  Billboard için Renk alanına göre renk belirle
        let colorName;
        if ((type === "Billboard" || type === "Megalight" || type === "Wallboard" || type==="Giantboard") && r.Renk) {
          colorName = getColorFromRenk(r.Renk) || "blue";
        }
        else {
          colorName = (type && typeToColor[type]) || "red";
        }


        return {
          id: `p${idx + 1}`,
          lat: Number.isFinite(lat) ? lat : null,
          lng: Number.isFinite(lng) ? lng : null,
          title: r["Adres"] || type || `Konum #${idx + 1}`,
          address: r["Adres"] || null,
          type,
          colorName,
          raw: r,
        };
      })
      .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  }, [rawData]);

  // ---- Başlangıç merkezi
  const initialCenter = useMemo(() => {
    if (!points.length) return centerFallback;
    const sum = points.reduce((acc, p) => ({ lat: acc.lat + p.lat, lng: acc.lng + p.lng }), { lat: 0, lng: 0 });
    return { lat: sum.lat / points.length, lng: sum.lng / points.length };
  }, [points, centerFallback]);

  // ---- Controlled center: sadece ilk kez set et
  const [mapCenter, setMapCenter] = useState(initialCenter);
  const [didCenterOnce, setDidCenterOnce] = useState(false);
  const mapRef = useRef(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!didCenterOnce) {
      setMapCenter(initialCenter);
      setDidCenterOnce(true);
    }
  }, [initialCenter, didCenterOnce]);

  const onLoad = useCallback((map) => (mapRef.current = map), []);
  const onDragEnd = useCallback(() => {
    if (mapRef.current) setMapCenter(mapRef.current.getCenter().toJSON());
  }, []);

  // ---- Legend + Filtre
  const allTypes = useMemo(
    () => Array.from(new Set(points.map((p) => p.type).filter(Boolean))).sort(),
    [points]
  );
  // const [visibleTypes, setVisibleTypes] = useState(() => new Set(allTypes)); // hepsi açık başla
  const [visibleTypes, setVisibleTypes] = useState(() => new Set(["Billboard"])); // hepsi açık başla

  // allTypes değişirse (data güncellenirse) görünürlüğü senkronla
  useEffect(() => {
    setVisibleTypes((prev) => {
      const next = new Set(prev);

      // Yeni gelen tipleri otomatik AÇMA
      // Ama artık olmayanları kapat
      for (const t of Array.from(next)) {
        if (!allTypes.includes(t)) next.delete(t);
      }

      // Eğer Billboard varsa ama seçili değilse → default olarak aç
      if (allTypes.includes("Billboard") && next.size === 0) {
        next.add("Billboard");
      }

      return next;
    });
  }, [allTypes]);


  const toggleType = (t) =>
    setVisibleTypes((s) => {
      const n = new Set(s);
      n.has(t) ? n.delete(t) : n.add(t);
      return n;
    });

  const setAll = (on) => setVisibleTypes(new Set(on ? allTypes : []));

  const legendItems = useMemo(
    () =>
      allTypes.map((label) => {
        let iconSrc;

        if (label === "Billboard") iconSrc = BILLBOARD_SVG;
        else if (label === "Giantboard") iconSrc = GIANTBOARD_SVG;
        else if (label === "Megalight") iconSrc = MEGALIGHT_SVG;
        else if (label === "Wallboard") iconSrc = WALLBOARD_SVG;
        else if (label === "LCW Mağazaları") iconSrc = STORE_SVG_DATA_URL;
        else {
          const color = typeToColor[label] || "red";
          iconSrc = `https://maps.google.com/mapfiles/ms/icons/${color}-dot.png`;
        }

        return { label, iconSrc, checked: visibleTypes.has(label) };
      }),
    [allTypes, visibleTypes]
  );


  if (loadError) return <div style={{ padding: 12, color: "#b00020" }}>Harita yüklenirken hata: {String(loadError.message || loadError)}</div>;
  if (!isLoaded) return <div>Harita yükleniyor…</div>;

  // ---- InfoWindow stilleri
  const cardStyle = { maxWidth: 260, display: "grid", gap: 8, fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif" };
  const titleStyle = { margin: 0, fontSize: 16, fontWeight: 600 };
  const metaStyle = { margin: 0, fontSize: 13, lineHeight: 1.4, opacity: 0.9 };
  const infoOpts = { maxWidth: 280, pixelOffset: new window.google.maps.Size(0, -8) };

  const getMarkerIcon = (colorName, type) =>
    type === "LCW Mağazaları"
      ? { url: STORE_SVG_DATA_URL, scaledSize: new window.google.maps.Size(40, 27), anchor: new window.google.maps.Point(14, 28) }
      : `https://maps.google.com/mapfiles/ms/icons/${colorName}-dot.png`;

  // ---- Filtre uygulanmış noktalar
  const visiblePoints = points.filter((p) => !p.type || visibleTypes.has(p.type));

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <div
        style={{
          height: "800px",
          width: "80%",
          margin: "40px auto",
          borderRadius: 8,
          overflow: "hidden",
          boxShadow: "0 2px 10px rgba(0,0,0,.2)",
          position: "relative",
        }}
      >
        <GoogleMap
          center={mapCenter}
          zoom={zoom}
          onLoad={onLoad}
          onDragEnd={onDragEnd}
          mapContainerStyle={{ height: "100%", width: "100%" }}
          options={{ gestureHandling: "greedy" }}
        >
          {visiblePoints.map((p) => (
            <Marker
              key={p.id}
              position={{ lat: p.lat, lng: p.lng }}
              onClick={() => setActive(p)}
              icon={getMarkerIcon(p.colorName, p.type)}
            />
          ))}

          {active && (
            <InfoWindow position={{ lat: active.lat, lng: active.lng }} onCloseClick={() => setActive(null)} options={infoOpts}>
              <div style={cardStyle}>
                <h3 style={titleStyle}>{active.title}</h3>
                {active.address && (
                  <p style={metaStyle}>
                    <strong>Adres:</strong> {active.address}
                  </p>
                )}
                {active.type && (
                  <p style={metaStyle}>
                    <strong>Tür:</strong> {active.type}
                  </p>
                )}
                {/* {active.raw?.ERİŞİM && (
                  <p style={metaStyle}>
                    <strong>Erişim:</strong> {active.raw.ERİŞİM}
                  </p>
                )} */}
                {active.raw?.["Ortalama Haftalık Tekil Kişi"] && (
                  <p style={metaStyle}>
                    <strong>Haftalık Tekil Kişi:</strong> {Math.round(Number(active.raw["Ortalama Haftalık Tekil Kişi"])).toLocaleString("tr-TR")}
                  </p>
                )}
                {active.raw?.Frekans && (
                  <p style={metaStyle}>
                    <strong>Frekans:</strong> {Number(active.raw.Frekans).toFixed(2)}
                  </p>
                )}
                {(active.raw?.A || active.raw?.B || active.raw?.C || active.raw?.DE) && (
                  <p style={metaStyle}>
                    <strong>SES:</strong> A: {active.raw.A} | B: {active.raw.B} | C: {active.raw.C} | DE: {active.raw.DE}
                  </p>
                )}
                {/* {active.raw?.Renk && (
                  <p style={metaStyle}>
                    <strong>Renk:</strong> {active.raw.Renk}
                  </p>
                )} */}
              </div>
            </InfoWindow>
          )}
        </GoogleMap>

        {/* Legend + Filtre */}
        <div
          style={{
            position: "absolute",
            left: 12,
            bottom: 12,
            background: "rgba(255,255,255,.95)",
            padding: "10px 12px",
            borderRadius: 8,
            boxShadow: "0 1px 6px rgba(0,0,0,.2)",
            fontSize: 13,
            minWidth: 210,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
            {/* <div style={{ fontWeight: 600 }}>Katman Renkleri</div> */}
            <div style={{ display: "flex", gap: 6 }}>
              <button onClick={() => setAll(true)} style={{ fontSize: 12, padding: "2px 6px", border: "1px solid #ddd", borderRadius: 6, background: "#fff" }}>
                Tümünü Aç
              </button>
              <button onClick={() => setAll(false)} style={{ fontSize: 12, padding: "2px 6px", border: "1px solid #ddd", borderRadius: 6, background: "#fff" }}>
                Kapat
              </button>
            </div>
          </div>

          {legendItems.map((it) => (
            <label key={it.label} style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={it.checked}
                onChange={() => toggleType(it.label)}
                style={{ margin: 0 }}
              />
              <img alt={it.label} width={18} height={18} src={it.iconSrc} />
              <span>{it.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
